"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clinicType = exports.transformCoachesDropdown = void 0;
var slugify = function (str) {
    return str
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/[\s_-]+/g, '-')
        .replace(/^-+|-+$/g, '');
};
exports.transformCoachesDropdown = function (data) {
    var coaches = [{ label: 'Alle coaches', value: 'default' }];
    if (data.length) {
        data.map(function (item) {
            var entry = {
                label: item.name,
                value: slugify(item.name),
            };
            coaches.push(entry);
        });
    }
    return coaches;
};
exports.clinicType = function (type) {
    switch (type) {
        case 'regular':
            return 'Regulier';
        case 'standard':
            return 'Doorstroom';
        case 'lekkerfit':
            return 'Lekker fit';
        case 'sbo':
            return 'SBO';
        default:
            return type;
    }
};
var transformAgendaOverview = function (data) {
    var entries = data.map(function (item) {
        var _a = item.clinic, name = _a.name, sport = _a.sport;
        var id = item.id, cancelled = item.cancelled;
        return {
            id: id,
            date: item.clinic_start_time,
            coach: item.user.name,
            coachSlug: item.user.name ? slugify(item.user.name) : '',
            name: name,
            sport: sport,
            type: exports.clinicType(item.clinic.type),
            school: item.school_name,
            cancelled: cancelled,
        };
    });
    return entries;
};
exports.default = transformAgendaOverview;
